import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { logout } from "../../store/loginReducer";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import LogoutConfirmModal from "./LogoutConfirmModal";

const LogoutButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const role = location.pathname.includes("/student") ? "student" : "admin";
  const [showModal, setShowModal] = useState(false);

  const handleLogout = () => {
    dispatch(logout(role));
    navigate(role === "student" ? "/student" : "/admin");
  };

  return (
    <div className="relative">
      <div
        onClick={() => setShowModal(true)}
        className="flex items-center gap-2 px-3 pt-2 pb-3"
      >
        <span className="cursor-pointer text-black text-sm flex items-center gap-2">
          <span>🚪</span>
          Logout
        </span>
      </div>

      {showModal && (
        <LogoutConfirmModal
          onConfirm={handleLogout}
          onCancel={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

export default LogoutButton;
